import pickBy from 'lodash.pickby';
import get from 'lodash.get';

import { deepSnakeCase } from '../../utils/transforms';

const JSON_HEADERS = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};

export const requestInterceptor = config => ({
    ...config,
    headers: {
        ...JSON_HEADERS,
        ...get(config, 'headers', {}),
    },
    params: pickBy(deepSnakeCase(config.params)),
    data: deepSnakeCase(config.data),
});
